<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-tabs fixed-tabs dark :background-color="`${buttonColor}`" v-model="tab">
                        <v-tab>{{ $t("registerEvent.registration") }}</v-tab>
                        <v-tab :disabled="!bShowDescription" @click="getEventDescription">{{
                        $t("registerEvent.description") }}</v-tab>
                    </v-tabs>
                </v-card>
            </v-col>
        </v-row>

        <v-row no-gutters class="mb-4">
            <v-col cols="12" class="px-2 pb-2">
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-row no-gutters class="mb-4">
                            <v-col cols="12" class="px-2 pb-2">
                                <WarningAlert>
                                    <p class="mb-0 font-weight-bold" style="font-size: 20px;">
                                        {{ $t("registerEvent.practice.alert_title").replace('[__PRACTICE_NAME__]', this.practiceName) }}
                                    </p>
                                    <p style="margin-bottom:0;">{{ $t("registerEvent.practice.alert_subtitle") }}</p>
                                </WarningAlert>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="mb-4">
                            <v-col md="12" sm="12" cols="12" class="pa-2">
                                <v-btn v-if="emergencyContactAll" :color="`${buttonColor}`" class="btn_next mr-12 my-1"
                                @click="addEmergencyContact">{{ $t("registerEvent.add_emergency_contact") }}</v-btn>
                            </v-col>
                            <v-col cols="12" class="px-2 pb-2">
                                <v-data-table 
                                    v-if="participantsSel" 
                                    :headers="ridersHeaders" 
                                    :items="participantsSel"
                                    :options="{ itemsPerPage: -1 }" 
                                    sort-by="name" 
                                    class="elevation-1 dt_part" 
                                    item-key="firstName"
                                    :item-class="rowClass" 
                                    dense
                                    :footer-props="{
                                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                                    }"
                                    :no-data-text="$t('dataTable.noDataText')"
                                    :headerProps="{
                                        'sort-by-text': $t('dataTable.sortByText')
                                    }"
                                >
                                    <template v-slot:[`header.selected`]="">
                                        <v-checkbox @change="updateAllChecks($event)" v-model="allCheck"></v-checkbox>
                                    </template>
                                    <template v-slot:[`item.selected`]="{ item }">
                                        <v-checkbox v-if="Array.isArray(registrationObj.practicesSel) && registrationObj.practicesSel.find(reg => reg.practiceId == practice.id && reg.userId == item.userId)"
                                            :disabled="isregistrationDisabled(item)"
                                            v-model="registrationObj.practicesSel.find(reg => reg.practiceId == practice.id && reg.userId == item.userId).status"
                                            @change="updateCheck({ practiceId: practice.id, status: $event, userId: item.userId })"></v-checkbox>
                                    </template>
                                    <template v-slot:[`item.emergencyContact`]="{ item }">
                                        <v-icon v-if="item.emergencyContact" color="green">fas fa-check-circle</v-icon>
                                        <span v-else style="color:red;">{{ $t("riders.emergency_contact_missing") }}</span>
                                    </template>
                                    <template v-slot:[`item.birthday`]="{ item }">
                                        <span>{{ item.age }}</span>
                                    </template>
                                    <template v-slot:[`item.price`]="{ item }">
                                        <td class="text-right">
                                            <span>${{ getParticipantPracticePrice(getAge(item.birthday)) }}</span>
                                        </td>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-tab-item>

                    <v-tab-item>
                        <DescriptionEvent :registrationObj="registrationObj" :eventDescription="eventDescription" />
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6">
                <v-btn :color="buttonColor" class="btn_next my-1" @click="prevStep()">
                    {{ $t("registerEvent.prev") }}
                </v-btn>
            </v-col>
            <v-col cols="6">
                <v-btn :color="buttonColor" class="btn_next my-1 float-right" @click="validatePractice()"
                    :loading="loadingToStepParticipant">
                    {{ $t("registerEvent.next") }}
                </v-btn>
            </v-col>
        </v-row>

        <v-dialog v-model="noPracticeRegistrationsDialog" max-width="450px">
            <v-card>
                <v-card-title>{{ $t("registerEvent.practice.not_mandatory_dialog_title") }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="text--primary mt-4">
                    {{ $t("registerEvent.practice.not_mandatory_dialog_description") }}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" text @click="noPracticeRegistrationsDialog = false">
                            {{ $t("registerEvent.practice.not_mandatory_dialog_cancel") }}
                        </v-btn>

                        <v-btn color="green darken-1" text @click="nextStep()">
                            {{ $t("registerEvent.practice.not_mandatory_dialog_ok") }}
                        </v-btn>
                    </v-card-actions>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import
{
    VRow, VCol, VBtn, VCheckbox, VIcon, VDialog, VCard, VCardTitle, VCardActions, VCardText, VDivider, VSpacer,
    VDataTable, VTabs, VTab, VTabsItems, VTabItem
} from 'vuetify/lib';
import WarningAlert from "@/components/alert/WarningAlert";
import DescriptionEvent from "@/components/eventRegistration/DescriptionEvent";
import LocalStorageService from "@/services/LocalStorageService";

export default {
    components: {
        VRow, VCol, VBtn, VCheckbox, VIcon, VDialog, VCard, VCardTitle, VCardActions, VCardText, VDivider, VSpacer,
        VDataTable, VTabs, VTab, VTabsItems, VTabItem,
        WarningAlert, DescriptionEvent,
    },
    props: {
        step: {
            type: Object,
            default: null
        },
        registrationObj: Object,
        loadingToStepParticipant: { type: Boolean, default: false },
        eventDescription: String
    },
    data()
    {
        return {
            buttonColor: "#000",
            add_people: false,
            cont: 0,
            waiverBam: false,
            waiverModal: false,
            waiverE: {},
            alertQuestion: false,
            waiverEArray: [],
            selectedSigWaiver: [],
            resetWaiver: false,
            tab: 0,
            noPracticeRegistrationsDialog: false,
            allCheck: false,
            role: 'Participant',
            waiverRequiredDialog: false,
            bSendWaiver: false,
            isShowPractice: false
        }
    },
    computed: {
        practice()
        {
            return this.registrationObj.eventSel.practices[this.step.componentIndex - 1];
        },
        practiceName()
        {
            if (!this.practice || this.practice.translations.length == 0) return '';

            try
            {
                return this.practice.translations.find(t => t.practiceName && t.language.languageCode == this.$i18n.locale).practiceName;
            } catch (error)
            {
                return this.practice.translations[0].practiceName;
            }
        },
        ridersHeaders()
        {
            let header = [
                { text: this.$t("registerEvent.selected"), value: 'selected', width: "10%", sortable: false },
                { text: this.$t("riders.first_name"), align: "", value: "fName" },
                { text: this.$t("riders.last_name"), value: "lName" },
                { text: this.$t("common.age"), value: "birthday", align: "center" }, 
                { text: this.$t("riders.emergency_contact"), value: "emergencyContact", align: "center" }
            ];
            header.push({ text: this.$t("registerEvent.price"), value: "price", align: "center" });
            return header;
        },
        participantsSel()
        {
            if (this.registrationObj)
            {
                if (!(this.registrationObj.eventSel != null && this.registrationObj.eventSel.isSpectatorRegistration == 0))
                {
                    let participants = this.registrationObj.participants.filter((el) =>
                    {
                        let find = (this.registrationObj.participantsSel || []).find((el1) => el1.userId == el.userId);
                        return !!find;
                    }).map((el) => {
                        return {
                            ...el,
                            age: this.getAge((el.birthday != 1 && el.birthday != 0) ? el.birthday : el.birthdayString),
                            //practiceStatus: this.getPracticeRegistration(el).status
                        };
                    });
                    return participants;
                }
                return this.registrationObj.participants.map((el) => {
                    return {
                        ...el,
                        age: this.getAge((el.birthday != 1 && el.birthday != 0) ? el.birthday : el.birthdayString),
                        //practiceStatus: this.getPracticeRegistration(el).status
                    };
                });
            }
            return [];
        },
        practicesSel()
        {
            return this.registrationObj.practicesSel;
        },
        selections()
        {
            return (this.registrationObj.practicesSel || []).length > 0 ? (this.registrationObj.practicesSel || []).filter((el) => el.practiceId == this.practice.id && el.status).length : 0;
        },
        curStep()
        {
            return this.registrationObj.step;
        },
        promoterName()
        {
            if (this.registrationObj && this.registrationObj.promoterSel)
            {
                return this.registrationObj.promoterSel.promoterName;
            }
            return '';
        },
        emergencyContactAll()
        {
            if (this.registrationObj)
            {
                const emergencyContactFailed = Array.isArray(this.participantsSel) ? this.participantsSel.filter((el) =>
                {
                    return el.emergencyContact == 0;
                }) : [];
                return emergencyContactFailed.length > 0;
            }
            return false;
        }
    },
    watch: {
        curStep()
        {
            this.tab = 0;
        }
    },
    methods: {
        bShowDescription()
        {
            if (this.registrationObj.eventSel)
            {
                return (
                    (this.registrationObj.eventSel.address || "").length > 0 ||
                    (this.registrationObj.eventSel.city || "").length > 0 ||
                    (this.registrationObj.eventSel.state || "").length > 0 ||
                    (this.registrationObj.eventSel.country || "").length > 0 ||
                    (this.registrationObj.eventSel.zip || "").length > 0 ||
                    (this.eventDescription || "").length > 0
                );
            }
            return false;
        },
        getEventDescription()
        {
            this.$emit('getEventDescription');
        },
        updateAllChecks(checkboxStatus)
        {
            const updateList = this.participantsSel.filter((participant) => {
                const practiceProcessed = (this.practicesSel || []).find(ps => ps.userId == participant.userId && ps.practiceId == this.practice.id);
                const practiceOrigin = this.registrationObj.practicesSel.find(ps => ps.userId == participant.userId && ps.practiceId == this.practice.id);
                return !this.isregistrationDisabled(participant) && (practiceProcessed || practiceOrigin).status != checkboxStatus;
            }).map(obj => obj.userId);
            updateList.forEach((userId) =>
            {
                const data = {
                    status: checkboxStatus,
                    userId: userId,
                    practiceId: this.practice.id
                };

                this.$nextTick(()=>{
                    this.updateCheck(data);
                })
            });
        },
        prevStep()
        {
            this.$emit('nextStep', (this.step.id - 1));
        },
        nextStep()
        {   
            if(this.validateItemsPractice()) {
                this.noPracticeRegistrationsDialog = false;
                this.$emit('nextStep', (this.step.id + 1));
            }
        },
        validateItemsPractice() {
            let isValidContactPractice = true;
            this.practicesSel.forEach((participant) => {
                if(participant.status) {
                    this.participantsSel.forEach((part) => {
                        if(part.userId == participant.userId && !part.emergencyContact) {
                            isValidContactPractice = false;
                        }
                    });
                }
            });
            if(!isValidContactPractice) {
                this.$emit('showAlert', { msg: this.$t('registerEvent.emergency_contact_error'), color: 'error' });
            }
            return isValidContactPractice;
        },
        validatePractice()
        {
            if (this.selections > 0)
                this.nextStep();
            else
                this.noPracticeRegistrationsDialog = true;
        },
        updateCheck(data)
        {
            this.$emit('updatePracticeParticipants', data);
        },
        rowClass(item)
        {
            return this.isregistrationDisabled(item) && 'grayC';
        },
        isregistrationDisabled(item)
        {
            return !!this.practice.blocked_registrations.find(obj => obj.fkUsersId == item.userId && obj.status == 'completed') || !item.emergencyContact;
        },
        getParticipantPracticePrice(participantAge)
        {
            let ammount;
            try
            {
                ammount = this.practice.prices.filter((obj) => (obj.ageMin <= participantAge && obj.ageMax >= participantAge) ||
                    (!obj.ageMin && !obj.ageMax) ||
                    (!obj.ageMin && obj.ageMax && obj.ageMax >= participantAge) ||
                    (obj.ageMin && obj.ageMin <= participantAge && !obj.ageMax)
                ).reduce((total, obj) => total + obj.price, 0);
            } catch (error)
            {
                ammount = 0;
            }

            return ammount.toFixed(2);
        },
        getAge(dob)
        {
            const getAge = this.$options.filters.getAge;
            return getAge(dob);
        },
        updatePracticeSelections()
        {
            this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');

            (this.participantsSel || []).forEach((el) => {
                this.updateCheck({
                    practiceId: this.practice.id,
                    status: false,
                    userId: el.userId,
                    practicePrice: this.getParticipantPracticePrice(this.getAge(el.birthday))
                });
            });
        },
        age18Calculate(birthdayCurrent)
        {
            const nowDay = new Date();
            nowDay.setFullYear(nowDay.getFullYear() - 18);
            if (birthdayCurrent)
            {
                const birthday = new Date(birthdayCurrent);
                return birthday <= nowDay;
            }
            return false;
        },
        addEmergencyContact()
        {
            LocalStorageService.setItem('active_event_registration', true);
            this.$router.push({
                path: 'emergencycontact'
            });
        },
        getRegistrantPractice(item) {
            if(this.registrationObj) {
                return (this.registrationObj.practicesSel || []).find(reg => reg.practiceId == this.practice.id && reg.userId == item.userId)
            }
            return false;
        }
    },
    created()
    {
        this.updatePracticeSelections();
    },
    mounted() {}
}
</script>